module.exports = __webpack_public_path__ + "static/media/networkCenterImg1.95d700cc.png";